import { Provider } from "react-redux";
import {
  Switch,
  Route,
  MemoryRouter,
  HashRouter,
  Redirect,
} from "react-router-dom";
import { createStore } from "./store/Store";
import CatalogContainer from "./components/containers/CatalogContainer/CatalogContainer";
import ReportContainer from "./components/containers/ReportContainer";
import Header from "./components/header/Header";
import GlobalAlert from "./components/global-alert/GlobalAlert";
import LocaleInitializer from "./LocaleInitializer";
import GoogleAnalyticsWrapper from "./GoogleAnalyticsWrapper";
import BusinessRulesContainer from "./components/containers/BusinessRulesContainer/BusinessRulesContainer";
import PreferencesModal from "./components/header/PreferencesModal";
import { ThemeProvider as CustomThemeProvider } from "./themeContext";
import { CssBaseline } from "@material-ui/core";
import { ThemeProvider as MuiThemeProvider } from "styled-components";
import { baseTheme as theme } from "./styles/themes/Theme";
import CallerAccountsModal from "./components/containers/account-selection/CallerAccountsModal";
import AccountSelection from "./components/containers/account-selection/AccountSelection";
import ProductAlertsScheduleModal from "./components/header/ProductAlersSchedule/ProductAlertsScheduleModal";
import ProductAlertsListContainer from "./components/header/ProductAlertsListModal/ProductAlertsListContainer";
import { DefaultLayout } from "layouts";
import { IS_WIDGET_ENABLED } from "utils/WidgetUtil";
import BadgeManagementModal from "components/header/BadgeManagement/BadgeManagementModal";
import PrecachingCrawlerModal from "./components/header/PrecachingCrawler/PrecachingCrawlerModal";
import LogoutPage from "./components/auth/LogoutPage";
import Auth0ErrorPage from "components/auth/Auth0ErrorPage";
import PerformanceContainer from "components/containers/PerformanceContainer/PerformanceContainer";
import { ChatbotEmbed } from "components/chatbot";
import BestSellersModal from "components/global-recommendations/BestSellersModal";
import TrendingProductsModal from "components/global-recommendations/TrendingProductsModal";
import ProtectedRoute from "./components/ProtectedRoute";
import PermissionDenied from "./components/PermissionDenied";
import { DefaultRouteRedirect } from "./components/DefaultRouteRedirect";

const RouterComponent: React.ComponentType = IS_WIDGET_ENABLED
  ? MemoryRouter
  : HashRouter;

function App() {
  return (
    <RouterComponent>
      <GoogleAnalyticsWrapper>
        <Provider store={createStore()}>
          <LocaleInitializer>
            <MuiThemeProvider theme={theme}>
              <CssBaseline />
              <CustomThemeProvider>
                <Switch>
                  <Route path="/logout">
                    <LogoutPage />
                  </Route>
                  <Route path="/auth0-error">
                    <Auth0ErrorPage />
                  </Route>
                  <DefaultLayout>
                    <AccountSelection />
                    <Header data-layout-role="header" />
                    <ProductAlertsListContainer />
                    <Switch>
                      <Route path="/permission-denied">
                        <PermissionDenied />
                      </Route>
                      <ProtectedRoute
                        path="/catalog"
                        requiredEntitlements={["catalog"]}
                      >
                        <CatalogContainer />
                      </ProtectedRoute>
                      <Route path="/reports">
                        <ReportContainer />
                      </Route>
                      <ProtectedRoute
                        path="/business-rules"
                        requiredEntitlements={["catalog"]}
                      >
                        <BusinessRulesContainer />
                      </ProtectedRoute>
                      <ProtectedRoute
                        path="/performance"
                        requiredEntitlements={["analytics"]}
                        requireFeatureFlag="performance-dashboard"
                      >
                        <PerformanceContainer />
                      </ProtectedRoute>
                      <Route path="/" exact>
                        <DefaultRouteRedirect />
                      </Route>
                      <Redirect to="/" />
                    </Switch>
                    <PreferencesModal />
                    <ProductAlertsScheduleModal />
                    <BadgeManagementModal />
                    <PrecachingCrawlerModal />
                    <CallerAccountsModal />
                    <BestSellersModal />
                    <TrendingProductsModal />
                    <GlobalAlert />
                    <ChatbotEmbed />
                  </DefaultLayout>
                </Switch>
              </CustomThemeProvider>
            </MuiThemeProvider>
          </LocaleInitializer>
        </Provider>
      </GoogleAnalyticsWrapper>
    </RouterComponent>
  );
}

export default App;
